/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@angular/router';
import * as i2 from '../../shared/spinner/spinner.component.ngfactory';
import * as i3 from '../../../../app/shared/spinner/spinner.component';
import * as i4 from '@angular/common';
import * as i5 from '../../../../app/layout/auth/auth.component';
const styles_AuthComponent:any[] = ([] as any[]);
export const RenderType_AuthComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_AuthComponent,data:{}});
export function View_AuthComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,16777216,(null as any),(null as any),3,'router-outlet',
      ([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      i0.ɵdid(1,212992,(null as any),0,i1.RouterOutlet,[i1.ChildrenOutletContexts,
          i0.ViewContainerRef,i0.ComponentFactoryResolver,[8,(null as any)],i0.ChangeDetectorRef],
          (null as any),(null as any)),(_l()(),i0.ɵeld(2,0,(null as any),(null as any),
          1,'app-spinner',([] as any[]),(null as any),(null as any),(null as any),
          i2.View_SpinnerComponent_0,i2.RenderType_SpinnerComponent)),i0.ɵdid(3,180224,
          (null as any),0,i3.SpinnerComponent,[i1.Router,i4.DOCUMENT],(null as any),
          (null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export function View_AuthComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'app-auth',([] as any[]),
      (null as any),(null as any),(null as any),View_AuthComponent_0,RenderType_AuthComponent)),
      i0.ɵdid(1,114688,(null as any),0,i5.AuthComponent,([] as any[]),(null as any),
          (null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const AuthComponentNgFactory:i0.ComponentFactory<i5.AuthComponent> = i0.ɵccf('app-auth',
    i5.AuthComponent,View_AuthComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci9saWIvamVua2lucy9qb2JzL25vc3RyYS1tdWZpdC1pbmZvLXByb2Qvd29ya3NwYWNlL3NyYy9hcHAvbGF5b3V0L2F1dGgvYXV0aC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vdmFyL2xpYi9qZW5raW5zL2pvYnMvbm9zdHJhLW11Zml0LWluZm8tcHJvZC93b3Jrc3BhY2Uvc3JjL2FwcC9sYXlvdXQvYXV0aC9hdXRoLmNvbXBvbmVudC50cyIsIm5nOi8vL3Zhci9saWIvamVua2lucy9qb2JzL25vc3RyYS1tdWZpdC1pbmZvLXByb2Qvd29ya3NwYWNlL3NyYy9hcHAvbGF5b3V0L2F1dGgvYXV0aC5jb21wb25lbnQudHMuQXV0aENvbXBvbmVudC5odG1sIiwibmc6Ly8vdmFyL2xpYi9qZW5raW5zL2pvYnMvbm9zdHJhLW11Zml0LWluZm8tcHJvZC93b3Jrc3BhY2Uvc3JjL2FwcC9sYXlvdXQvYXV0aC9hdXRoLmNvbXBvbmVudC50cy5BdXRoQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPHJvdXRlci1vdXRsZXQ+PGFwcC1zcGlubmVyPjwvYXBwLXNwaW5uZXI+PC9yb3V0ZXItb3V0bGV0PiIsIjxhcHAtYXV0aD48L2FwcC1hdXRoPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7OztvQkNBQTtNQUFBO2FBQUE7MERBQUE7VUFBQSw2QkFBZTtVQUFBO21FQUFBLFVBQUE7VUFBQTtVQUFBO0lBQWY7Ozs7b0JDQUE7TUFBQTthQUFBO1VBQUE7SUFBQTs7OzsifQ==



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/nostra-mufit-info-prod/workspace/src/$$_gendir/app/layout/auth/auth.component.ngfactory.ts